import React from 'react';
import Icon from '@Components/Icon/Icon';
import { useDispatch } from 'react-redux';
import { Header, CardTitle } from './ShippingAddress.styled';
import { setModal } from '@Redux/modules/modal/actions';
import Divider from '@Components/Divider/Divider';

const TitleHeader = ({ title }: { title: string }): JSX.Element => {
	const dispatch = useDispatch();

	return (
		<>
			<Header>
				<CardTitle>{title}</CardTitle>
				<Icon
					name="close"
					fill="black87"
					onClick={() => {
						dispatch(
							setModal({
								data: null,
								type: null,
							})
						);
					}}
				/>
			</Header>
			<Divider marginTop={23} marginBottom={16} />
		</>
	);
};

export default TitleHeader;
